import React, { useEffect, useState, useRef } from "react";

const Countdown = ({ targetDate, onComplete }) => {
  const calculateTimeLeft = () => {
    const diff = +new Date(targetDate) - +new Date();
    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const hasCompletedRef = useRef(false);
  const onCompleteRef = useRef(onComplete);
  
  // Keep onComplete ref updated
  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);
  
  useEffect(() => {
    // Reset completion flag when targetDate changes (new round)
    hasCompletedRef.current = false;
    const initial = calculateTimeLeft();
    setTimeLeft(initial);
    
    const timer = setInterval(() => {
      const remainingMs = +new Date(targetDate) - +new Date();
      
      // Check if countdown reached zero
      if (remainingMs <= 0) {
        // Always show 0000 when time is up
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        
        // Call completion callback only once
        if (!hasCompletedRef.current && onCompleteRef.current) {
          hasCompletedRef.current = true;
          console.log('Countdown reached zero, calling onComplete callback');
          onCompleteRef.current();
        }
      } else {
        // Update with remaining time
        const next = calculateTimeLeft();
        setTimeLeft(next);
      }
    }, 1000);
    
    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap", // ✅ ensures it wraps instead of overflowing
        gap: "8px",
        justifyContent: "center",
        alignItems: "center",
        font: "inherit",
        color: "inherit",
        textAlign: "center",
      }}
    >
      <TimeBox label="Days" value={timeLeft.days} direction="reverse" />
      <TimeBox label="Hours" value={timeLeft.hours} direction="" />
      <TimeBox label="Minutes" value={timeLeft.minutes} direction="reverse" />
      <TimeBox label="Seconds" value={timeLeft.seconds} direction="" />
    </div>
  );
};

const TimeBox = ({ label, value, direction }) => (
  <div className="total-input" style={{flexDirection: "column", flex: "1"}}>
    <div
      style={{
        fontSize: "clamp(1.8rem, 2vw, 2rem)", // ✅ scales with screen width
        fontWeight: "bold",
        color: "#b8b8ba"
      }}
    >
      {String(value).padStart(2, "0")}
    </div>
    <div style={{ fontSize: "clamp(0.8rem, 1vw, 0.8rem)", opacity: "0.7" }}>
      {label}
    </div>
    <div className={"corner " + direction} data-colors="primary">
      <span className="corner-left"></span>
      <span className="corner-right"></span>
      <span className="corner-top-bottom"></span>
    </div>
  </div>
);

const Separator = () => (
  <span
    style={{
      fontSize: "clamp(1rem, 2rem, 2.5rem)", // ✅ scales as well
      opacity: 0.5,
    }}
  >
    :
  </span>
);

export default Countdown;
